<template>
    <div>
      <plantVariety-annuity-will-pay-list></plantVariety-annuity-will-pay-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  